import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Heading, Surface } from '@americanexpress/dls-react';
import TermsModal from '../../../view-all/components/TermsModal';
import { renderHTML } from '../../../../utilities/render-html';

function buildDisclosureCopy(disclosures = []) {
  const disclosureCopy = disclosures.reduce((previousDisclosure, currentDisclosure) => {
    const title = currentDisclosure?.title;
    const content = currentDisclosure?.content;
    const disclosure = `
      <h4 class="font-weight-bold">${title}</h4>
      <br/>
      ${content}
      <br/>
      <br/>
    `;

    return previousDisclosure + disclosure;
  }, '');

  return disclosureCopy;
}

export function TermBox(props) {
  const { localeDetails, benefitName, cardname, enrollment, disclosures } = props;
  const hasEnrollmentThankYou = enrollment?.data?.thankyou;
  const isPriorityPassOrPassSelect = benefitName === 'priority-pass' || benefitName === 'priority-pass-select';
  const hasBenefitTerms = disclosures?.find((disclosure) => disclosure.type === 'BENEFIT_TERMS');
  const hasAssuranceDisclosures = props.disclosures?.find((disclosure) => disclosure.type === 'ASSURANCE_DISCLOSURES');
  const disclosuresCopy = buildDisclosureCopy(disclosures);
  const safeDisclosureCopy = renderHTML(disclosuresCopy);
  const hasTermsOrDisclosures = hasBenefitTerms || hasAssuranceDisclosures;

  if (hasEnrollmentThankYou && isPriorityPassOrPassSelect) {
    // Thank you page does NOT show terms box, but AFC DOES
    return null;
  }

  if (hasTermsOrDisclosures) {
    return (
      <>
        <section id="enroll-page-terms-box">
          <Surface variant="foreground" className="pad-2-t pad-2-lr pad-3-t-lg-up pad-3-lr-lg-up">
            <hr />
            {
            hasBenefitTerms && (
              <>
                <Heading className="pad-2-t" level={3} variant="san-small-regular">
                  <FormattedMessage id="shared.terms-links.benefits-terms" defaultMessage="Benefit Terms" />
                </Heading>
                <div className="pad-2-t text-justify body"> {safeDisclosureCopy} </div>
              </>
            )
          }
            {
            hasAssuranceDisclosures && (
              <>
                <Heading className="pad-2-t" level={3} variant="san-small-regular">
                  &diams;Amex Assurance Disclosures
                </Heading>
                <div className="text-justify"> {safeDisclosureCopy} </div>
              </>
            )
          }
            <hr />
          </Surface>
        </section>
        <div className="flex flex-wrap width-full">
          <div className="pad-responsive stack flex flex-column flex-justify-center text-nowrap margin-0-lr">
            <TermsModal cardname={cardname} localeDetails={localeDetails} />
          </div>
        </div>
      </>
    );
  }

  return null;
}
